import React from 'react';
import { Shield, Users, Target, Search } from 'lucide-react';
const sections = [{
  icon: Shield,
  title: 'Your Trusted Partner in Tactical Consulting & Security Solutions',
  content: <p data-id="element-144">
        <strong className="text-brand-white" data-id="element-145">Medina Tactical Dynamics</strong>,
        founded in 2002, is a premier New Jersey-based consulting firm
        specializing in{' '}
        <strong className="text-brand-white" data-id="element-146">
          strategic security, training, investigations, and protection services
        </strong>
        . We are committed to delivering the highest level of expertise and
        professionalism to every client we serve.
      </p>
}, {
  icon: Users,
  title: 'A Team of Elite Professionals',
  content: <p data-id="element-147">
        Our team consists of{' '}
        <strong className="text-brand-white" data-id="element-148">
          certified and highly credentialed law enforcement professionals
        </strong>{' '}
        with extensive experience at the state and local levels. Having worked
        across the globe, we bring world-class expertise to our clients,
        collaborating with dedicated strategic partners to deliver unparalleled
        service and solutions.
      </p>
}, {
  icon: Target,
  title: 'A Commitment to Excellence',
  content: <p data-id="element-149">
        At Medina Tactical Dynamics, our mission is simple:{' '}
        <strong className="text-brand-white" data-id="element-150">
          to provide the highest level of service, ensuring our clients are
          prepared, protected, and empowered
        </strong>
        . We take a{' '}
        <strong className="text-brand-white" data-id="element-151">
          strategic, results-driven approach
        </strong>{' '}
        to readiness and preparedness, adapting to evolving security challenges
        with precision and professionalism.
      </p>
}, {
  icon: Search,
  title: 'Comprehensive Security & Investigative Services',
  content: <>
        <p data-id="element-152">
          We specialize in{' '}
          <strong className="text-brand-white" data-id="element-153">
            safety, security, risk assessments, investigations, and education
          </strong>
          , ensuring that our clients receive tailored solutions designed to
          meet their unique needs. Our team is fully engaged in providing
          proactive strategies that mitigate risks and enhance overall security.
        </p>
        <p className="mt-4" data-id="element-154">
          Partner with{' '}
          <strong className="text-brand-white" data-id="element-155">Medina Tactical Dynamics</strong>{' '}
          and experience the{' '}
          <strong className="text-brand-white" data-id="element-156">
            gold standard in tactical consulting and security solutions
          </strong>
          .
        </p>
      </>
}];
export function AboutSections() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16" data-id="element-158">
        {sections.map(section => {
        const Icon = section.icon;
        return <div key={section.title} className="flex gap-6 md:gap-8" data-id="element-159">
              <div className="flex-shrink-0 hidden sm:block" data-id="element-160">
                <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center" data-id="element-161">
                  <Icon className="w-6 h-6 text-brand-teal" data-id="element-162" />
                </div>
              </div>
              <div data-id="element-163">
                <h3 className="text-xl md:text-2xl font-bold text-brand-white uppercase tracking-wide mb-4" data-id="element-164">
                  {section.title}
                </h3>
                <div className="text-lg text-brand-gray-300 leading-relaxed" data-id="element-165">
                  {section.content}
                </div>
              </div>
            </div>;
      })}

        <div className="text-center pt-8" data-id="element-166">
          <a href="/meet-the-founder" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-8 py-4 text-base gap-2.5" data-id="element-167">
            Meet the Founder
          </a>
        </div>
      </div>
    </section>;
}